import { ToastType, useToast } from '@shared/context/Toast';
import { hasCRUDError } from '@shared/types';
import { useState } from 'react';
export function useServerHandler() {
    const [isLoading, setIsLoading] = useState(false);
    const { pushToast } = useToast();
    /**
     * @param action - The action to be executed. Must return a CRUD return promise that will be evaluated for errors.
     * If need to perform a transition without executing any actions, just return a Promise.resolve() on the action.
     */
    const doServerAction = (action, onSuccess, onFail) => {
        setIsLoading(true);
        action()
            .then(res => {
            if (hasCRUDError(res)) {
                pushToast({ message: res.error, type: ToastType.error });
                return;
            }
            onSuccess?.(res);
        })
            .catch(() => {
            pushToast({ message: 'Internal server error', type: ToastType.error });
            onFail?.();
        })
            .finally(() => {
            setIsLoading(false);
        });
    };
    return { isLoading, doServerAction };
}
//# sourceMappingURL=useServerHandler.js.map